document.addEventListener('DOMContentLoaded', function () {
  const infoIcons = document.querySelectorAll('.scalapay-info-icon');

  infoIcons.forEach(icon => {
    icon.addEventListener('click', function (e) {
      const tooltip = this.nextElementSibling;
      tooltip.classList.toggle('active');
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('scalapay-info-icon')) {
      document.querySelectorAll('.scalapay-tooltip.active').forEach(t => t.classList.remove('active'));
    }
  });
});
